export default __webpack_public_path__ + "static/media/tri-left.377994c6.svg";